import { ApiConstant } from "constants/ApiConstant";


export const COMMON_SKIP_ENCRYPTION_PATHS = [
  // ApiConstant.LOGIN,
  ApiConstant.LOGOUT,
  ApiConstant.ENCRYPTION
  // ApiConstant.SINGLE_CATEGORY_URL
];